<template>

    <filter-header
        @expand-all="expandAll"
        @collapse-all="collapseAll"
        @clear-filters="clearFilters"
    />


    <div class="filters-container">
        <div class="sr-only-focusable"   :tabindex="!filtersOpen && isMobile ? -1 : 0" v-html="copydeck.keyboard_users_notice?.fr ?? 'allo'"></div>
        <filter-group
            v-for="(group,index) in filters"
            :key="'group' + index"
            :group="group"
            ref="filterGroups"

        ></filter-group>


    </div>


    <div class="filters-results d-flex d-xl-none justify-content-center">
        <button class="filters-toggle-btn btn-rounded btn-color-blue"
                ref="btnResults" @click.prevent="closeFilters"
                :tabindex="filtersOpen ? 0 : -1"
                :aria-hidden="!filtersOpen"
        >

            <span class="dots-container">
                <span class="dot-falling"></span>
            </span>


            <span class="results">
                <span class="num-results-value" v-html="numResults"></span>
                <span class="unit" v-html=" numResults === 1 ? 'résultat' : 'résultats' "></span>
            </span>
        </button>
    </div>
</template>

<script setup>

import { computed, ref, onMounted, watch } from "vue";
import { useStore }                        from "vuex";
import { useQuerystring }                  from "../composables/URL";

//COMPONENTS
import FilterGroup  from "./FilterGroup";
import FilterHeader from "./FilterHeader";


//INIT
let store       = useStore();
let querystring = useQuerystring();

//computed
let copydeck          = computed( () => store.state.copydeck );
let filters      = computed( () => store.state.filters );
let filterGroups = ref( [] );

let props      = defineProps( [ "numResults" ] );
let emits      = defineEmits( [ "changeFilters" ] );
let numResults = computed( () => props.numResults );

let searchingTimeout;

let filtersOpen = computed( () => store.getters.areFiltersOpen );
let isMobile    = computed( () => store.getters.isMobile );


let btnResults = ref( null );
watch( numResults, ( newResults, oldResults ) =>
{

    // otherwise, the previous timeout might still be in the air,
    // hiding our animation almost immediately
    // if ever we're still animating, let's clear it.. which will NOT remove the class
    // and start a new one to remove it later
    if ( searchingTimeout )
    {
        clearTimeout( searchingTimeout );
    }

    // we were asked to fake the loading of results
    btnResults.value.classList.add( 'ajaxing' );
    searchingTimeout = setTimeout( () => btnResults.value.classList.remove( 'ajaxing' ), 2000 );
} );


watch( store.state.checked, ( newChecked, oldChecked ) =>
{
    emits( "changeFilters", newChecked );
} );


function closeFilters ()
{
    store.commit( 'toggleFiltersVisibility' )
}

function collapseAll ()
{

    filterGroups.value.forEach( fg => fg.collapseAll() );
}

function expandAll ()
{

    filterGroups.value.forEach( fg => fg.expandAll() );
}

function clearFilters ( justClear = false )
{

    //filterGroups.value.clearFilters();
    filterGroups.value.forEach( fg => fg.clearFilters() );

    if ( !justClear )
    {
        // store.commit( "clearAll" );
        store.dispatch( "search", { searchTerm : "" } );
    }
}

function mounted ()
{
    let type = querystring.type;

    if ( type === "descripteurs" )
    {
        let id = parseInt( querystring.id ?? 0 );

        store.commit( "checked", { checked : true, id, groupType : "" } );
    }

    const searchParams = new URLSearchParams( window.location.search );
    let filters        = searchParams.get( "f" )

    if ( filters )
    {
        filters = filters.split( "," ).filter( f => f !== "" );

        for ( let i = 0; i < filters.length; i++ )
        {
            let id = parseInt( filters[ i ] ?? 0 );
            store.commit( "checked", { checked : true, id, groupType : "" } );
        }
    }

    store.dispatch( "related" )
}

defineExpose( { clearFilters } );
onMounted( mounted );


</script>

<style scoped>

</style>
